import { KeysOfType } from 'src/app/helpers/utility-functions';
import ProductAsset from 'src/app/model/product-asset';
import { OfflineAsset } from '../../placer-offline-changes/offline-asset';
import { ToDoItem } from '../model/to-do-item';

export interface ImmoIPProductChangesObject {
  id: number;
  installerFeedback?: string;
  executionComplete?: boolean;
  executionDate?: Date;
  executionTime?: string;
  placed?: ToDoItem;
  extraBoard?: ToDoItem;
  immoscoop?: ToDoItem;
  spotto?: ToDoItem;
  poleColor?: ToDoItem;
  leftTitle?: ToDoItem;
  rightTitle?: ToDoItem;
  leftPhoneNumber?: ToDoItem;
  rightPhoneNumber?: ToDoItem;
  text?: ToDoItem;
  sticker?: ToDoItem;
  extras?: ToDoItem;
  safetyNut?: ToDoItem;
  safetyRibbon?: ToDoItem;
  offlineAssets?: OfflineAsset[];
  assets?: ProductAsset[];
}

// IMPORTANT: If you ever need to add a new ToDoItem, please add its property name to this array
export const toDoItemKeys = [
  'placed',
  'extraBoard',
  'immoscoop',
  'spotto',
  'poleColor',
  'leftTitle',
  'rightTitle',
  'leftPhoneNumber',
  'rightPhoneNumber',
  'text',
  'sticker',
  'extras',
  'safetyNut',
  'safetyRibbon',
];

export type ImmoIPProductChangesObjectToDoItemKey = KeysOfType<
  ImmoIPProductChangesObject,
  ToDoItem
>;

export function isProductToDoItemProp(
  prop: string
): prop is ImmoIPProductChangesObjectToDoItemKey {
  return toDoItemKeys.includes(prop);
}
